<template>
  <Breadcrumbs
    title="Stock Adjustment History"
    :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Adjustment History', path: '/stock-adjustment-history' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <stockAdjustmentHistoryForm />
    </div>
  </div>
</template>

<script>
import stockAdjustmentHistoryForm from "@/pages/stock/stock_adjustment_history/stockAdjustmentHistoryForm.vue";

export default {
  components: {
    stockAdjustmentHistoryForm,
  },
};
</script>